<ng-container *transloco="let t; read: 'conversation-config-editor'">
  <div *ngIf="!loading">
    <!---------------------------------------------->
    <!-- Available Times -->
    <!---------------------------------------------->

    <ng-template #objEditor>
      <!-- Available Times Editor-->
      <app-edit-available-hours-by-dow
        [description]="t('availableTimesDescription')"
        [(obj)]="availableTimesEditorInput"
      >
      </app-edit-available-hours-by-dow>
      <!-- Durations -->
      <form [formGroup]="form">
        <!-- Inactive After Duration -->
        <div class="field">
          <label for="inactiveAfterDuration">{{ t('inactiveAfterDurationLabel') }}</label>
          <div class="inputfield w-full">
            <p-inputNumber
              id="inactiveAfterDuration"
              mode="decimal"
              ariaLabel="{{ t('inactiveAfterDurationLabel') }}"
              [formControl]="inactiveAfterDuration"
              [max]="1440"
              [min]="5"
              [showButtons]="true"
              suffix=" {{ t('minutes') }}"
            >
            </p-inputNumber>
            <p id="inactiveAfterDuration-help">
              {{ t('inactiveAfterDurationHelp', { numMinutes: form.get('inactiveAfterDuration').value }) }}
            </p>
          </div>
        </div>
        <!-- Closed After Duration -->
        <div class="field">
          <label for="closedAfterDuration">{{ t('closedAfterDurationLabel') }}</label>
          <div class="inputfield w-full">
            <p-inputNumber
              id="closedAfterDuration"
              mode="decimal"
              ariaLabel="{{ t('closedAfterDurationLabel') }}"
              [formControl]="closedAfterDuration"
              [max]="240"
              [min]="15"
              [showButtons]="true"
              suffix=" {{ t('minutes') }}"
            >
            </p-inputNumber>
            <p id="closedAfterDuration-help">
              {{ t('closedAfterDurationHelp', { numMinutes: form.get('closedAfterDuration').value }) }}
            </p>
          </div>
        </div>
        <!-- Message Retention Duration -->
        <div class="field">
          <label for="pIIRetentionDuration">{{ t('pIIRetentionDurationLabel') }}</label>
          <div class="inputfield w-full">
            <p-inputNumber
              id="pIIRetentionDuration"
              mode="decimal"
              ariaLabel="{{ t('pIIRetentionDurationLabel') }}"
              [formControl]="pIIRetentionDuration"
              [max]="168"
              [min]="0"
              [showButtons]="true"
              suffix=" {{ t('hours') }}"
            >
            </p-inputNumber>
            <p id="pIIRetentionDuration-help">
              {{ t('pIIRetentionDurationHelp', { numHours: pIIRetentionDuration?.value }) }}
            </p>
          </div>
        </div>
        <!-- Quick Exit URL -->
        <div class="field">
          <label for="redirectURL">{{ t('redirectURLLabel') }}</label>
          <div class="inputfield w-full">
            <div class="p-inputgroup">
              <input
                id="redirectURL"
                pInputText
                placeholder="https://"
                type="text"
                [attr.aria-label]="t('redirectURLLabel')"
                [formControl]="redirectURL"
              />
            </div>
            <div id="redirectURL-help">
              <p *ngIf="form.get('redirectURL').errors?.errorCode" class="p-error">
                {{ t(form.get('redirectURL').errors?.errorCode) }}
              </p>
              <p *ngIf="form.get('redirectURL').value; else emptyRedirectHelp">
                {{ t('redirectURLHelp', { url: form.get('redirectURL').value }) }}
              </p>
              <ng-template #emptyRedirectHelp>
                <p>{{ t('redirectURLHelpEmpty') }}</p>
              </ng-template>
            </div>
          </div>
        </div>

        <!-- Waiting Room -->
        <div class="field">
          <p-checkbox
            id="waitingRoomConfigEnabled"
            ariaLabel="{{ t('waitingRoomConfigEnabledLabel') }}"
            [binary]="true"
            [formControl]="waitingRoomConfigEnabled"
            label="{{ t('waitingRoomConfigEnabledLabel') }}"
          >
          </p-checkbox>
          <p *ngIf="spamDetectionEnabled; else waitingRoomHelp" class="mt-1 mb-0 text-color-secondary">
            {{ t('spamDetectionConflict') }}
          </p>
          <ng-template #waitingRoomHelp>
            <p class="mt-1 mb-0" id="waitingRoomConfigEnabled-help">{{ t('waitingRoomConfigEnabledHelp') }}</p>
          </ng-template>
        </div>

        <!-- Capture Identity -->
        <div class="field">
          <p-checkbox
            id="captureIdentityToVendor"
            ariaLabel="{{ t('captureIdentityToVendorEnabledLabel') }}"
            [binary]="true"
            [formControl]="captureIdentityToVendorEnabled"
            label="{{ t('captureIdentityToVendorEnabledLabel') }}"
          >
          </p-checkbox>
          <div id="captureIdentityToVendorEnabled-help">
            <p>{{ t('captureIdentityToVendorEnabledHelp', { numHours: pIIRetentionDuration?.value }) }}</p>
          </div>
        </div>

        <div class="grid-nogutter p-fluid gap-3">
          <label for="serviceProviders">{{ t('notifyWithSMSLabel') }}</label>
          <div class="inputfield w-full gap-2">
            <app-workers-autocomplete
              id="serviceProviders"
              [formControl]="serviceProviders"
              [ngClass]="{ 'ng-invalid': serviceProviders?.invalid }"
              [unique]="false"
            >
            </app-workers-autocomplete>
            <app-form-field-help [control]="serviceProviders">
              <ng-container form-field-help-hint>
                {{ t('notifyWithSMSHelp') }}
              </ng-container>
            </app-form-field-help>
          </div>
        </div>

        <label class="flex flex-column gap-2 mt-3">
          <span>{{ t('communicationWorkflowLabel') }}</span>
          <app-communication-workflow-autocomplete
            [formControl]="communicationWorkflowId"
          ></app-communication-workflow-autocomplete>
        </label>
      </form>
    </ng-template>

    <app-settings
      [auditEntry]="auditEntry"
      [cardTitle]="t('title')"
      [doUpload]="upload"
      [editorTemplate]="objEditor"
      [isValid]="isValid"
      [refreshData]="refreshData"
      [resetForm]="updateUI"
    >
    </app-settings>
  </div>
  <p-progressSpinner *ngIf="loading"></p-progressSpinner>
</ng-container>
